<template>
  <div>
    <dialog-edit2 :value="value" @input="$emit('input')" :maxWidth="hasSource ? '1300' : '800'">
      <template v-slot:title> </template>
      <v-row>
        <v-col v-if="hasSource" cols="12" sm="6">
          <v-card-title class="pt-0"> Выбрать из... </v-card-title>
          <v-card-text style="max-height: 600px; overflow-y: auto">
            <a-form-model v-model="sourceD" :model="sourceM" :config="{ dense: true, readonly: true }" />
          </v-card-text>
        </v-col>
        <v-col cols="12" :sm="hasSource ? 6 : 12">
          <v-card-title class="pt-0"> {{ `Добавление изображений  ${model.title ? "[" + model.title + "]" : ""}` }}</v-card-title>
          <a-form-model v-model="data" :model="model" :errors="errors" :config="{ dense: true }" @validate="validate($event)" /> </v-col
      ></v-row>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <a-btn-save :disabled="!loaded" @click.once="submit()" />
        <v-btn @click.once="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit2>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, getAccess } from "@/components/mixings";

export default {
  components: {},
  mixins: [getForm, submitForm, removeEl, getAccess],
  props: {
    value: Boolean,
    id: Number,
    api: String,
    modelDoc: Object,
  },
  data() {
    return {
      loaded: false,
      sourceD: null,
      sourceM: null,
      hasSource: false,
    };
  },
  computed: {
    model() {
      let model = JSON.parse(JSON.stringify(this.modelDoc));
      model.validator = ["req"];
      model.newOnly = true;
      //return [model];
      return [model, { name: "filesAdd", default: [], hidden: true }, { name: "filesTask", default: [], hidden: true }];
    },
  },
  watch: {
    value() {
      if (this.value) {
        this.updateData(this.id);
        if (!this.id) {
        }
      }
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.loaded = !true;
      if (this.value) {
        await this.updateData(this.id);
        this.loaded = true;
        if (!this.id) {
        }
      }
    },
    afterFetchData(r) {
      this.getSource(r?.data?.data);
    },
    async getSource(data) {
      if (!data) return;
      let params = { filters: { object_id: data.object_id, createdby_id: this.$root.profile.id } };
      let resp = await this.$axios.get("mechti/construction-reports", { params });

      if (resp.data.data.length) {
        this.sourceD = {};
        this.sourceM = [];
        let d = {},
          m = [];
        for (let i = 0; i < resp.data.data.length; i++) {
          const el = resp.data.data[i];
          d[`id${el.id}`] = el.photos;
          m.push({ name: `id${el.id}`, type: "imagesdrag", title: `Отчет №${el.id}` });
        }
        console.log({ d, m });
        this.sourceD = Object.assign({}, d);
        this.sourceM = m;
        this.hasSource = true;
      }
    },
    async submit() {
      let data = {
        id: this.data.id,
        [this.modelDoc.name]: this.data[this.modelDoc.name],
      };
      if (!this.data.id) return false;
      if (!data?.[this.modelDoc.name]) return false;
      await this.post(data, this.api);
      return true;
    },
    afterSave(data, status) {
      this.$emit("input");
      // this.$router.push({name: "objects_view", params: {id: this.id}});
    },
  },
};
</script>
